import React, { useState } from "react";
import MoneySuccess from "../../../assets/images/moneySuccess.png";
import Award from "../../../assets/images/Award.png";
import Logo from "../../../assets/images/logo.jpg";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useParams } from "react-router-dom";
import { claimStatus } from "../../auth/redux/store";
import ReactGA from 'react-ga4';

export const TransferSucces = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const transferSuccessTextWithBreak = t("transferSuccessText").replace(
    "<br>",
    "<br>"
  );
  const [loading, setLoading] = useState(false);
  const genunityData = useSelector((state) => state?.genunityData);
  const amount = useSelector((state) => state?.amount);
  const navigate = useNavigate(); 
  const dispatch = useDispatch(); 
  dispatch(claimStatus(false));

  return (
    <>
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <div className="card-body px-2 pt-0 pb-2 d-block m-auto">
              <div className="px-4 py-2 mt-5">
                <h6
                  className="transferSuccessText"
                  dangerouslySetInnerHTML={{
                    __html: transferSuccessTextWithBreak,
                  }}
                ></h6>
                <img
                  src={MoneySuccess}
                  alt="MoneySuccessImg"
                  className="d-block m-auto MoneySuccessImg"
                />

                <p className="successSubtitileText">{t("successSubtitile")}</p>

                <div className="d-flex justify-content-center mt-4 align-items-center">
                  <img src={Award} alt="Award" />
                  <p className="ml-4 mb-0 amount">₹ {amount}</p>
                </div>

                <div
                  className=""
                  style={{
                    position: "fixed",
                    bottom: "0rem",
                    width: "100%",
                    left: "0",
                  }}
                >
                  <img
                    src={Logo}
                    alt="Logo"
                    className="footerLogo"
                    style={{ width: "200px", display: "block", margin: "auto" }}
                  />

                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3
                  center-textbtn mt-3 text-white text-uppercase"
                    id="submitBtn" style={{borderRadius:'0'}}
                    onClick={() => {
                      ReactGA.event({
                        category: 'Transfer Success',
                        label: 'Home From Transfer Success',
                        action: 'Home Btn Clicked From Transfer Success',
                      });
                      navigate(`/${lang}/home`) }}
                  >
                    {t("goHome")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
